$(document).ready(function() {

	var video = $('#customVideo').get(0);

	$(document).on('click', '.video-sound-btn', function () {
		const videoId = $(this).data('id');

		var video = $('#video-' + videoId).get(0);

		video.muted = !video.muted;
		if (video.muted) {
			$(this).find('i').removeClass('fa-volume-up').addClass('fa-volume-mute');
		} else {
			$(this).find('i').removeClass('fa-volume-mute').addClass('fa-volume-up');
		}
	});

	// if($('.banner-hero-sided').length > 0) {
	// 	const bannerHeroSided = Plyr.setup('.banner-hero-sided', {
	// 		controls: ['play-large','play'],
	// 		// ratio: ratioPlayer,
	// 		ratio: '430:760',
	// 		autoplay: true
	// 	});
	// }

	

	if($('.banner-video-hero').length > 0) {
		const bannerVideoHero = Plyr.setup('.banner-video-hero', {
			controls: ['play-large','play'],
			// ratio: ratioPlayer,
			// ratio: '430:760',
			// autoplay: true
		});
	}

	$(window).scroll(function(){
		if ($(this).scrollTop() > 100) {
			$('.product-bottom-bar').addClass("active");
		} else {
			$('.product-bottom-bar').removeClass("active");
		}
	});

	$(document).on('click', '#readmore', function() {
		$('#show-content').toggleClass('show-less');
		$('#readmore').addClass('d-none');
		$('#readless').removeClass('d-none');
	});
	$(document).on('click', '#readless', function() {
		$('#show-content').toggleClass('show-less');
		$('#readmore').removeClass('d-none');
		$('#readless').addClass('d-none');
	});



	if ($(".swiper-flip").length > 0 ) {
		var flipSwiper = new Swiper(".swiper-flip", {
            grabCursor: false,
            navigation: {
                nextEl: ".swiper-flip-next",
                prevEl: ".swiper-flip-prev",
            },
            pagination: {
                el: ".swiper-pagination-flip",
				dynamicBullets: true,
                clickable: true
            },
            loop: false,
			effect: window.innerWidth > 640 ? "creative" : "slide",
            slidesPerView: 1,
            loopedSlides: 1,
            observer: true,
            creativeEffect: {
                limitProgress:2,
                prev: {
					shadow: true,
					translate: ["-105%", 0, -250],
                },
                next: {
					shadow: true,
					translate: ["20%", 0, -250],
                },
            },
            breakpoints: {
                640: {
					slidesPerView: 1.25,
					spaceBetween: 20,
                }
            }
        });

        flipSwiper.on('slideChangeTransitionEnd', () => {
            document.querySelectorAll('.swiper-flip .swiper-slide:not(.swiper-slide-active) .ingredient-flip-card.flipped').forEach((fItem) => {
                fItem.classList.remove('flipped');
            });
        })

        // $(document).on('click', '.card-flip-trigger', function() {
		// 	console.log('test .card-flip-trigger');
        //     $(this).parent('.ingredient-flip-card').toggleClass('flipped');
        // });
        $(document).on('click', '.swiper-wrapper', function() {
			$(this).find('.swiper-slide-active').find('.ingredient-flip-card').toggleClass('flipped');
        });
	}

	if ($('.gallery-thumbs').length > 0 && $('.gallery-images').length > 0) {
		var swiperGalleryThumbs = new Swiper(".gallery-thumbs", {
			loop: false,
			spaceBetween: 0,
			slidesPerView: 5,
			slidesPerGroup: 5,
			centeredSlides: false,
			centeredSlidesBounds: true,
			centeredSlidesBounds: true,
			watchOverflow: true,
			watchSlidesVisibility: true,
			watchSlidesProgress: true,
			direction: 'vertical',
			observer: true,
			navigation: {
				nextEl: '.swiper-button--thumb-next',
				prevEl: '.swiper-button--thumb-prev',
				hideOnClick: false,
				disabledClass: 'swiper-button--disabled',
			}
		});

		var swiperGalleryImages = new Swiper(".gallery-images", {
			loop: false,
			slidesPerView: 1,
			spaceBetween: 8,
			scrollbar: false,
			threshold: 10,
			observer: true,
			breakpointsInverse: true,
			thumbs: {
				swiper: '.gallery-thumbs',
			},
			pagination: {
				el: ".swiper-pagination",
			},
			breakpoints: {
				320: {
					slidesPerView: 1,

				},
				768: {
					slidesPerView: 1,
				}
			}
		});
	}

	$(document).on('click', '.menu-category', function() {
		window.location = $(this).attr('href');
	});

    // window.onload = function () {
    //     $('.preloader-wrapper').fadeOut(500, function(){
    //         $('.preloader-wrapper').remove();
    //     });
    // }

	$('.select2').select2();

	/* A function that toggles the class active on the button and changes the type of the input field to
	text or password. */
	$(".btn-password").on("click", function(e)
	{
		$(this).toggleClass('active');
		if ( $(this).hasClass('active') )
		{
			$(this).siblings('.form-control').attr("type","text");
		} else
		{
			$(this).siblings('.form-control').attr("type","password");
		}
	});

    $(".btn-submenu").on("click", function(e)
	{
		e.preventDefault();
		let submenu = $(this).siblings('.submenu');
		submenu.slideToggle();
	});

	/* A jQuery function that is toggling the class active on the element with the class submenu-btn. */
	// $('.side-menu-link').on('mouseenter', function() {
	// 	$(this).siblings('.submenu-btn').toggleClass('active');
	// 	$(this).siblings('.drop-list').slideToggle();
    // });
	// $('.side-menu-link').on('mouseleave', function() {
	// 	$(this).siblings('.submenu-btn').toggleClass('active');
	// 	$(this).siblings('.drop-list').slideToggle();
	// });
	$(".side-menu-link").on('click', function(e) {
		e.preventDefault();
		$(this).siblings('.submenu-btn').toggleClass('active');
		$(this).siblings('.drop-list').slideToggle();
	});
	// $(".submenu-btn").on('click', function(e) {
	// 	e.preventDefault();
	// 	$(this).toggleClass('active');
	// 	$(this).siblings('.drop-list').slideToggle();
	// });
	$(".filter-show-dropdown").on('click', function(e) {
		e.preventDefault();
		$(this).toggleClass('active');
		$(this).siblings('.submenu-btn').toggleClass('active');
		$(this).siblings('.drop-list').slideToggle();
	});

	/* A function that is initializing the Perfect Scrollbar library. */
	if ( $('.scroll-box').length > 0 )
	{
		const ps = new
			PerfectScrollbar('.scroll-box', {
			wheelSpeed: 2,
			// wheelPropagation: true,
			minScrollbarLength: 20,
			// maxScrollbarLength: 63,
			useBothWheelAxes: true
		});
	}


	/* A function that is toggling the class active on the element with the class submenu-btn. */
	const button = document.querySelector('.card.template-menu .card-link');
	if(button) {
		const hiddenItems = document.querySelectorAll('.card.template-menu .card-menu--item.d-none');
		const cardMenu = document.querySelectorAll('.card.template-menu');
		let isHidden = true;
		button.addEventListener('click', (e) => {
			e.preventDefault();
			button.textContent = isHidden
			? 'Vezi mai putine'
			: 'Vezi mai multe';

			isHidden = !isHidden;
			console.log(cardMenu);
			hiddenItems.forEach(item => item.classList.toggle('d-none'));
			$(cardMenu).toggleClass('opened');
		});
	}

	/* This is a datepicker. */
	// locale setup
	const localeEn = {
		days: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
		daysShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
		daysMin: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
		months: ['January','February','March','April','May','June', 'July','August','September','October','November','December'],
		monthsShort: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
		today: 'Today',
		clear: 'Clear',
		dateFormat: 'dd/MM/yyyy',
		timeFormat: 'hh:ii aa',
		firstDay: 1
	}
	// creating date picker with locale
	new AirDatepicker('.input-date', {
		locale: localeEn,
		dateFormat: 'dd-MM-yyyy'
	})


	const counters = document.querySelectorAll('.counter-value');
	const speed = 200;

	counters.forEach( counter => {
		const animate = () => {
			const value = +counter.getAttribute('counter');
			const data = +counter.innerText;

			const time = value / speed;
			if(data < value) {
				counter.innerText = Math.ceil(data + time);
				setTimeout(animate, 1);
				}else{
				counter.innerText = value;
				}

		}

		animate();
	});

	/* A function that is initializing the AOS library. */
	AOS.init();

    // Example starter JavaScript for disabling form submissions if there are invalid fields
	(() => {
		'use strict'

		// Fetch all the forms we want to apply custom Bootstrap validation styles to
		const forms = document.querySelectorAll('.needs-validation')

		// Loop over them and prevent submission
		Array.from(forms).forEach(form => {
		form.addEventListener('submit', event => {
			if (!form.checkValidity()) {
			event.preventDefault()
			event.stopPropagation()
			}

			form.classList.add('was-validated')
		}, false)
		})
	})()
	// Check screen width
	var screenWidth = window.screen.width;
	ratioPlayer = null;
	if (screenWidth > 768) 
	{
		ratioPlayer = '7:3';
	}
	
	if ( $('.player-hero').length > 0 ) {
		var playerHero;
		$('.player-hero').each(function(index, item) {
			playerHero = new Plyr('#player-hero-'+$(item).data('mid'), {
				controls: ['play', 'mute'],
				ratio: ratioPlayer
			});
		});
	}

	// JavaScript to handle the parallax scrolling effect on the text
	// document.addEventListener('scroll', function () {
	// 	const scrollPosition = window.pageYOffset;
	// 	const parallaxElements = document.querySelectorAll('.parallax-text');

	// 	parallaxElements.forEach(element => {
	// 		const speed = element.getAttribute('data-speed');
	// 		element.style.transform = 'translateY(calc(-50% - ' + (scrollPosition * 0.1) + 'px))';
	// 	});
	// });

	// const parallaxElements = document.querySelectorAll('.parallax-text');

    // // Create an Intersection Observer
    // const observer = new IntersectionObserver((entries) => {
    //     entries.forEach(entry => {
    //         if (entry.isIntersecting) {
    //             entry.target.style.opacity = 1; // Make text visible when it comes into view
    //             entry.target.classList.add('in-view');
    //         } else {
    //             entry.target.style.opacity = 0; // Hide text when it leaves view
    //             entry.target.classList.remove('in-view');
    //         }
    //     });
    // }, {
    //     threshold: 0.1 // Adjust this value as needed
    // });

    // // Observe each parallax element
    // parallaxElements.forEach(element => {
    //     observer.observe(element);
    // });

    // // Handle the parallax effect on scroll
    // document.addEventListener('scroll', () => {
    //     const scrollPosition = window.pageYOffset;

    //     parallaxElements.forEach(element => {
    //         if (element.classList.contains('in-view')) { // Only move the element if it's in view
    //             const speed = element.getAttribute('data-speed');
    //             const parentOffset = element.closest('.template-banner--hero').offsetTop;
    //             const relativeScroll = scrollPosition - parentOffset;
    //             element.style.transform = `translateY(calc(-50% - ${relativeScroll * 0.1}px))`;
	// 			// element.style.transform = 'translateY(calc(-50% - ' + (scrollPosition * 0.1) + 'px))';
    //         }
    //     });
    // });

	// var triggerElTab = document.querySelector('.menu-category')
	// bootstrap.Tab.getInstance(triggerElTab).show() // Select tab by name
	
	// $(triggerElTab).on('hove', function(e) {
	// 	// e.preventDefault();
	// 	console.log('works');
	// 	$(this).toggleClass('active');
	// 	// $(this).siblings('.drop-list').slideToggle();
	// });
	document.querySelectorAll('#menu-category-tab .nav-link').forEach(function(everyitem){ 	
	
		var tabTrigger = new bootstrap.Tab(everyitem)
		everyitem.addEventListener('mouseenter', function(){
			tabTrigger.show();
		});
		
	});

	

});



// WEBPACK FOOTER //
// ./resources/assets/js/regular/general.js